import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { URL } from "../../lib/apis";
import Navbar from "../home/Navbar";
import Footer from "../home/Footer";

interface SignupFormInputs {
  phone_number: string;
}

interface User {
  user_id: string;
  name: string;
  email: string;
  phone_number: string;
  token: string; // Token field
  expiresInTime: number; // Field for expiration time
}

const Signup = () => {
  const [loading, setLoading] = useState(false); // State to track loading
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isNavbarShrunk, setIsNavbarShrunk] = useState(false);
  const { t } = useTranslation()

  // Gestion du scroll pour la navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsNavbarShrunk(true);
      } else {
        setIsNavbarShrunk(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SignupFormInputs>();

  const navigate = useNavigate();

  const onSubmit = async (data: SignupFormInputs) => {
    setLoading(true); // Start loading when form is submitted
    console.log("phonnne", data.phone_number)
    const postData = {
      phone_number: `+237${data.phone_number}`, // Format phone number with country code
      role: "client",
    };

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${URL}/users/login-app`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(postData),
    };

    try {
      // Send login request
      const response = await axios.request<{
        token: string;
        user: User;
        expiresInTime: number; // Add expiresInTime to response type
      }>(config); // Define response type

      const { token, user, expiresInTime } = response.data; // Extract token and user data

      // Store the user and token in localStorage
      const userData = { ...user, token, expiresInTime };
  
      // Show success message and navigate to OTP page
      toast.success(`Connexion réussie !!!`);
      navigate("/signup_otp", {state: userData});
    } catch (error: any) {
      console.error("Error during sign-up:", error);
      toast.error("Veuillez réessayer !!!");
      toast.error(error.response.data.message);
    } finally {
      setLoading(false); // Stop loading when request completes
    }
  };

  return (
    <div className="flex flex-col w-full min-h-screen bg-white">
      <Navbar isSidebarOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
        isShrunk={isNavbarShrunk} />
      <div className="flex flex-1 flex-col items-center mt-[100px] md:mt-[98px] justify-center min-h-screen bg-gray-100 gap-10">
        <div className="my-2">
          <img className="w-[200px] h-[100px]" src="/assets/logo_black.png" alt="logo" />
        </div>
        <Card className="w-[400px] h-[280px] shadow-lg rounded-lg bg-gray">
          <CardHeader>
            <div className="flex items-center justify-center">
              <CardTitle>{t("inscrire")}</CardTitle>
            </div>
            <div
              className="flex items-center justify-center"
              style={{ color: "#868889", marginTop: "10%" }}
            >
              <CardDescription>
                {t("entrer_numero")}
              </CardDescription>
            </div>
          </CardHeader>

          <CardContent>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex flex-col items-center"
            >
              <div className="grid w-full items-center gap-4 my-4">
                <div className="flex flex-col space-y-1.5 w-full max-w-xs">
                  <Label htmlFor="phone_number">{t("numere_phone")}</Label>
                  <div className="flex">
                    <span className="border border-gray-300 bg-gray-200 rounded-l-md py-2 px-3 text-gray-600">
                      +237
                    </span>

                    <Input
                      id="phone"
                      type="tel"
                      placeholder="entrez votre numero"
                      {...register("phone_number", {
                        required: "Phone number is required",
                        pattern: {
                          value: /^6[0-9]{8}$/,
                          message: "Enter a valid phone number",
                        },
                      })}
                    />
                  </div>

                  {errors.phone_number && (
                    <span className="text-red-500">
                      {errors.phone_number.message}
                    </span>
                  )}
                </div>
              </div>
              <CardFooter className="flex flex-col items-center gap-2 my-2">
                <Button
                  type="submit"
                  disabled={loading} // Disable button while loading
                  className={`w-[340px] text-white rounded-full py-2 px-4 ${loading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "hover:bg-green-500"
                    }`}
                  style={{ borderRadius: "50px", height: "2.5em" }}
                >
                  {loading ? "Chargement..." : "Suivant"}
                </Button>
              </CardFooter>
            </form>

          </CardContent>
        </Card>
        <ToastContainer />
      </div>
      <div className="w-full">
        <Footer />
      </div>

    </div>

  );
};

export default Signup;
